import { ALERT_VIEWED } from 'src/app/shared/dataAnalytics/schema/constants';
import { callbackOnDifference } from 'src/app/utils/callbackOnDifference';
import {
  type TrackingFnProps,
  MAX_EMOJI_LENGTH_VALIDATOR_NAME,
} from 'src/app/utils/validation';
import getTrackingAdapter from 'src/app/v1/dataAnalytics';

const ruleName = MAX_EMOJI_LENGTH_VALIDATOR_NAME;

export const sendMaxEmojiLengthTrackingEvents = ({
  validationResult,
  fieldName,
}: TrackingFnProps) => {
  const { errors } = validationResult;
  const error = errors.find(
    ({ rule, fieldName: errorFieldName }) =>
      errorFieldName === fieldName && rule === ruleName,
  );

  // Only send tracking event when error message changes
  // not if they stay the same....
  callbackOnDifference({
    callback: () => {
      if (!error) return;

      getTrackingAdapter.sendLinkEvent({
        alertShownTone: 'critical',
        alertShownMessage: error?.message,
        alertShownMessageCode: 'Too many emojis',
        eventName: ALERT_VIEWED,
        fieldName,
      });
    },
    data: error?.message,
    fieldName,
    ruleName,
  });
};
